import React, { useState, useEffect } from "react";
import "./App.less"
import { DatePicker, Button, Icon, Input, Select, Switch, Tooltip, Tag, Modal } from '@kdcloudjs/kdesign'
import { inputStyle, selectionStyle, selectTagStyle } from "./style"
import { chartdir } from "./config"

const normalScheme = { id: "NScheme", schemeName: "常用条件过滤", default: false }

function APP(props) {
    console.log("===filt app===", props);

    const {
        model,
        filtParams,
        myInvoke,
        updateState,
        makeSingleEvent,
        editStatus,
        searchLoading,
        showOrgTeam,
        makeInitParams,
        getFullParams,
        schemes,
        showScheme,
        maxLevel
    } = props

    const { invoke } = model

    // 前方案
    const [preShowScheme, setPreShowScheme] = useState(showScheme ?? null)

    // 方案输入框
    const [showSchemeName, setShowSchemeName] = useState(showScheme?.schemeName ?? "")

    // 过滤面板
    const [showFilt, setShowFilt] = useState(false)

    // 元方案（是否星号）
    const [mateScheme, setMateScheme] = useState(true)

    // 新增方案状态
    const [addSchemeStatus, setAddSchemeStatus] = useState(false)

    // 方案下拉框（受控）
    const [showSchemeBoard, setShowSchemeBoard] = useState(false)

    useEffect(() => {
        if ((showScheme?.id ?? null) === "NScheme") {
            setShowFilt(true)
        }
    }, [showScheme])

    // 切换条件联动
    const changeQueryConditionHandle = (filtParams, flag = true) => {

        if (flag) {
            updateState("showOrgTeam", null)
        }

        invoke("changeQueryCondition", {
            coopreltypes: [filtParams?.showCooprelTypes?.id ?? null],
            currentOrgChartRootNodeId: flag ? null : (showOrgTeam?.id ?? null),
            chartStyleId: filtParams?.chartStyle?.id ?? null,
            datefield: filtParams?.queryDate,
            teamotclassify: filtParams?.showOtclassifys,
            orgs: filtParams?.orgs.map(item => item.id)
        })
    }

    // 查询日期
    const changeSearchDate = (date, dateString) => {
        const _filtParams = {
            ...filtParams,
            queryDate: dateString
        }

        updateState("filtParams", _filtParams)

        setMateScheme(false)

        changeQueryConditionHandle(_filtParams)
    }

    // 个性化开关
    function handleOPS(value) {
        updateState("filtParams", {
            ...filtParams,
            isOpenPersonalStyle: value,
        })

        setMateScheme(false)

        if (value) {
            invoke("openPersonalStyle", {
                chartStyleId: filtParams?.chartStyle.id,
                rootorg: showOrgTeam?.id ?? null,
                orgs: filtParams?.orgs.map(item => item.id)
            })
        } else {
            invoke("closePersonalStyle", {
                chartStyleId: filtParams?.chartStyle.id,
                rootorg: showOrgTeam?.id ?? null
            })
        }
    }

    // 结构图方向
    function handleDir(value) {
        setMateScheme(false)

        updateState("filtParams", {
            ...filtParams,
            orgchartdirection: value ?? "1",
        })
    }

    // 显示层级
    function handleLevel(value) {
        setMateScheme(false)

        updateState("filtParams", {
            ...filtParams,
            showLevel: value ?? 1,
        })
    }

    // 选择/切换方案
    function handleSchmes(value, option) {
        const _showScheme = option.item
        // 如果是方案新增状态
        if (addSchemeStatus) {
            Modal.confirm({
                title: "操作确认",
                body: (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <img src="data:image/png;base64,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" />
                        <p style={{ marginTop: "15px" }}>检测到您有新增方案，是否不保存直接切换？</p>
                        <p>若不保存，将丢失这些更改。</p>
                    </div>
                ),
                cancelText: "仍要切换",
                okText: "立即保存",
                onCancel: () => {
                    handleSchmesSure(_showScheme)
                },
                onOk: () => {
                    addScheme()
                }
            })
        } else {
            handleSchmesSure(_showScheme)
        }
    }

    // 打开新增方案
    const handleAddScheme = () => {
        setShowSchemeBoard(false)

        setMateScheme(true)

        // 处于方案新增的状态
        setAddSchemeStatus(true)

        setShowFilt(true)

        setPreShowScheme(showScheme)

        updateState("showScheme", null)

        setShowSchemeName("")
    }

    // 删除方案
    const delScheme = () => {
        // 恢复到方案查看状态
        setAddSchemeStatus(false)

        if (!showScheme) {
            updateState("showScheme", normalScheme)
            setShowSchemeName("")
        } else {
            myInvoke("deleteScheme", { schemeId: showScheme?.id ?? null }, "deleteScheme")
                .then(data => {
                    const _schemes = data?.schemes ?? []

                    updateState("schemes", [normalScheme, ..._schemes])

                    updateState("showScheme", normalScheme)

                    setShowSchemeName("")

                    submitFiltForm()
                })
        }

    }

    // 保存方案
    const addScheme = () => {
        const _newScheme = {
            schemeId: showScheme?.id ?? null,
            schemeName: showSchemeName,
            scheme: getFullParams()
        }

        myInvoke("saveOrUpdateScheme", _newScheme, "saveOrUpdateScheme")
            .then(data => {
                if (!data.showScheme) return

                setPreShowScheme(showScheme)

                // 回到方案查看态
                setAddSchemeStatus(false)

                // 元方案
                setMateScheme(true)

                // 更新方案数据：方案列表、当前方案
                updateSchemeInfo(data)

                // 使用新方案查询数据
                useSelectedScheme(data?.showScheme.id)
            })
    }

    // 变更默认方案
    const setDefaultScheme = flag => {
        if (!showScheme) return

        const _newScheme = {
            schemeId: showScheme?.id ?? null,
            isDefault: flag
        }

        myInvoke("setDefaultScheme", _newScheme, "setDefaultScheme")
            .then(data => {
                updateSchemeInfo(data)
            })
    }

    // 确定选择/切换方案
    function handleSchmesSure(_showScheme) {
        setPreShowScheme(showScheme ?? null)

        if (_showScheme.id === "NScheme") {
            updateState("showScheme", _showScheme)

            // 元方案
            setMateScheme(true)
            // 退出方案新增状态
            setAddSchemeStatus(false)
            // 查询
            invoke("commonConditionQuery")
        } else {
            useSelectedScheme(_showScheme.id)
        }
    }

    // 使用切换的方案
    const useSelectedScheme = schemeId => {
        invoke("schemeQueryOrgChart", { schemeId })

        myInvoke("analyseScheme", { schemeId }, "analyseScheme")
            .then(data => {
                if (!data || !data.showScheme) return
                // ===切换方案成功===
                // 当前选中方案
                updateState("showScheme", data.showScheme)
                // 元方案
                setMateScheme(true)
                // 退出方案新增状态
                setAddSchemeStatus(false)
                // 当前输入框的方案名称
                setShowSchemeName(data.showScheme.schemeName)

                // ===应用方案===
                updateState("filtParams", {
                    ...makeInitParams(data)
                })

                updateState("showOrgTeam", data.showOrgTeam)
            })
    }

    const updateSchemeInfo = data => {
        const _schemes = data?.schemes ?? []

        const _showScheme = data?.showScheme ?? null

        updateState("schemes", [normalScheme, ..._schemes])

        updateState("showScheme", _showScheme)

        setShowSchemeName(_showScheme.schemeName)
    }

    const opScheme = (params) => {
        switch (params.value) {
            // 取消默认
            case "0":
                setDefaultScheme(false)
                break;
            // 设为默认
            case "1":
                setDefaultScheme(true)
                break;
            // 删除
            case "2":
                delScheme()
                break;

        }
    }

    // 查询
    const submitFiltForm = () => {
        updateState("searchLoading", true)

        invoke("searchChartData", getFullParams())
    }

    // 汇报及协作关系
    const makeOpenTeamCooprelTypeF7 = () => {
        myInvoke("openTeamCooprelTypeF7", {}, "openTeamCooprelTypeF7")
            .then(data => {

                const _filtParams = {
                    ...filtParams,
                    showCooprelTypes: data.data
                }

                updateState("filtParams", _filtParams)

                changeQueryConditionHandle(_filtParams, false)
            })
    }

    // 结构图样式
    const makeOpenOrgChartStyleF7 = () => {
        myInvoke("openOrgChartStyleF7", {}, "openOrgChartStyleF7")
            .then(data => {
                if (!data) return

                updateState("filtParams", {
                    ...filtParams,
                    chartStyle: data?.data ?? null,
                    hasPersonalStyle: data?.hasPersonalStyle ?? false,
                    isOpenPersonalStyle: data?.isOpenPersonalStyle ?? false,
                    personalStyle: data?.personalStyle ?? null
                })

            })
    }

    // 主管责任单位
    const makeOpenOrgF7 = () => {
        myInvoke("openOrgF7", {}, "openOrgF7")
            .then(data => {
                if (!data) return

                const _filtParams = {
                    ...filtParams,
                    orgs: data.orgs
                }

                updateState("filtParams", _filtParams)

                changeQueryConditionHandle(_filtParams)
            })
    }

    // 行政组织类型
    const makeOpenAdminOrgTypeF7 = () => {
        invoke("openAdminOrgTypeF7", { orgs: filtParams?.orgs.map(item => item.id) })
    }

    // 个性化样式
    const makeOpenPersonalStyleF7 = () => {
        myInvoke("openPersonalStyleF7", { chartStyleId: filtParams?.chartStyle.id }, "personalStyleData")
            .then(data => {
                updateState("filtParams", {
                    ...filtParams,
                    personalStyle: data?.data ?? null
                })
            })
    }

    makeSingleEvent("updateSchemesList", updateProps => {
        const _schemes = updateProps?.schemes ?? []
        updateState("schemes", [normalScheme, ..._schemes])

        updateState("showScheme", preShowScheme)

        schemes.find(schemeItem => {
            if (schemeItem === preShowScheme) {
                setShowSchemeName(schemeItem.schemeName)
                return true
            }
        })
    })

    makeSingleEvent("donothing", () => {
        updateState("showScheme", preShowScheme)

        schemes.find(schemeItem => {
            if (schemeItem === preShowScheme) {
                setShowSchemeName(schemeItem.schemeName)
                return true
            }
        })
    })

    return (
        <div className="filt-wrapper" style={{ display: editStatus ? 'none' : '' }}>
            <div className="filt-bar">
                <div className="plan">
                    <Select
                        className={"filt-select " + ((!mateScheme && showScheme?.id !== "NScheme") ? "not-curr" : "")}
                        borderType="bordered"
                        placeholder=""
                        style={{ width: "180px" }}
                        listHeight={184}
                        value={showScheme?.id ?? null}
                        onChange={handleSchmes}
                        visible={showSchemeBoard}
                        onSelect={() => { setShowSchemeBoard(false) }}
                        onVisibleChange={flag => { setShowSchemeBoard(flag) }}
                        dropdownRender={(menu) => (
                            <div>
                                {menu}
                                <div style={selectionStyle}>
                                    <Button type="ghost" className="compose-btn" onClick={handleAddScheme} disabled={addSchemeStatus} style={{ width: "156px" }}>
                                        <Icon type="add" />新增方案
                                    </Button>
                                </div>
                            </div>
                        )}>
                        {[...schemes].map((item) => {
                            return (
                                <Option key={item.id} value={item.id} size="small" item={item} style={{}}>
                                    {item.schemeName}{item.default ? (
                                        <Tag type="attribute" color="end" style={selectTagStyle}  >
                                            默认
                                        </Tag>
                                    ) : ""}
                                </Option>
                            )
                        })}
                    </Select>
                </div>
                <Button type="text" className="i-collapse-board-btn" onClick={() => {
                    setShowFilt(!showFilt)
                }}>
                    {showFilt ? (<>收起过滤<Icon className="icon" type="arrow-up" /></>) : (<>展开过滤<Icon className="icon" type="arrow-down" /></>)}
                </Button>
            </div>
            <div className="filt-board" style={{ display: showFilt ? "" : "none" }}>
                {(showScheme?.id !== "NScheme" || addSchemeStatus) && (
                    <div className="scheme-edit">
                        <div className="form-group">
                            <div className="title required">
                                <span className="txt">方案名称</span>
                            </div>
                            <div className="info">
                                <Input
                                    value={showSchemeName}
                                    borderType="bordered"
                                    style={inputStyle}
                                    placeholder="请填写方案名称"
                                    onChange={e => {
                                        setShowSchemeName(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="title required">
                                <span className="txt">查询组织</span>
                                <Tooltip placement="bottomLeft" tip="查询组织由左树选定的组织带入。查看方案时，结构图的顶点为查询组织，如需修改方案的查询组织，可更换左树选定的组织后点击保存按钮。">
                                    <Icon className="icon" type="tips" />
                                </Tooltip>
                            </div>
                            <div className="info">
                                <Input
                                    value={showOrgTeam?.name ?? ""}
                                    borderType="bordered"
                                    style={inputStyle}
                                    placeholder="当前查询结果为空，请切换条件"
                                    disabled
                                // suffix={<Icon className="inp-icon" type="search" onClick={makeOpenOrgTeamF7} />}
                                />
                            </div>
                        </div>
                        <div className="form-btn-group" style={{ paddingTop: "9px" }} >
                            <Button.Dropdown
                                className="i-drop-btn"
                                popperStyle={{ zIndex: 1000 }}
                                ghost
                                type="similar"
                                overlay={(() => {
                                    if (!showScheme) {
                                        return [
                                            { value: '2', label: '取消' },
                                        ]
                                    } else {
                                        if (showScheme?.default ?? false) {
                                            return [
                                                { value: '0', label: '取消默认' },
                                                { value: '2', label: '删除' },
                                            ]
                                        } else {
                                            return [
                                                { value: '1', label: '设为默认' },
                                                { value: '2', label: '删除' },
                                            ]
                                        }
                                    }
                                })()}
                                onClick={addScheme}
                                onItemClick={opScheme}>
                                保存
                            </Button.Dropdown>
                        </div>
                    </div>
                )}
                <div className="filt-list">
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">主管责任单位</span>
                        </div>
                        <div className="info">
                            <Input className="i-ellipsis-inp"
                                value={(() => {
                                    return filtParams?.orgs.reduce((t1, t2) => t1 + ";" + t2.name, "").substr(1)
                                })()}
                                borderType="bordered"
                                style={inputStyle}
                                placeholder="请选择主管责任单位"
                                suffix={<Icon className="inp-icon" type="search" onClick={makeOpenOrgF7} />}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="title required">
                            <span className="txt">查询日期</span>
                        </div>
                        <div className="info">
                            <DatePicker className="i-date-style" allowClear={false} inputReadOnly={true} disabledDate={(date) => {
                                return date && date > new Date()
                            }} borderType="bordered" style={inputStyle} value={new Date(filtParams?.queryDate)} onChange={changeSearchDate}
                            // suffixIcon={<Icon className="inp-icon" type="date" />}
                            />
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">结构图样式</span>
                        </div>
                        <div className="info">
                            <Input
                                value={filtParams?.chartStyle?.name ?? ""}
                                borderType="bordered"
                                style={inputStyle}
                                placeholder="请选择结构图样式"
                                suffix={<Icon className="inp-icon" type="search" onClick={makeOpenOrgChartStyleF7} />}
                            />
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">个性化样式</span>
                            <Tooltip placement="bottomLeft" tip="打开个性化开关">
                                <Icon className="icon" type="tips" />
                            </Tooltip>
                        </div>
                        <div className="info">
                            <Switch checked={!!(filtParams?.isOpenPersonalStyle ?? false)} onChange={handleOPS} disabled={!filtParams?.hasPersonalStyle} size="large" />
                        </div>
                    </div>
                    {!!(filtParams?.isOpenPersonalStyle ?? false) && (
                        <div className="form-group" >
                            <div className="title required">
                                <span className="txt">个性化样式名称</span>
                            </div>
                            <div className="info">
                                <Input
                                    value={filtParams?.personalStyle?.name ?? ""}
                                    borderType="bordered"
                                    style={inputStyle}
                                    placeholder="请选择个性化样式名称"
                                    suffix={<Icon className="inp-icon" type="search" onClick={makeOpenPersonalStyleF7} />}
                                />
                            </div>
                        </div>
                    )}

                    {!(filtParams?.isOpenPersonalStyle ?? false) && (
                        <>
                            <div className="form-group" >
                                <div className="title required">结构图方向</div>
                                <div className="info">
                                    <Select borderType="bordered" value={filtParams?.orgchartdirection ?? "1"} onChange={handleDir} placeholder="选择方向" style={inputStyle}>
                                        {chartdir.map(item => {
                                            return (
                                                <Option key={item.value} value={item.value}>{item.name}</Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                            </div>
                            <div className="form-group" >
                                <div className="title required">
                                    显示层级
                                    <Tooltip placement="bottomLeft" tip="数据的层级小于显示层级时，将以实际数据的层级进行展示">
                                        <Icon className="icon" type="tips" />
                                    </Tooltip>
                                </div>
                                <div className="info">
                                    <Select borderType="bordered" value={filtParams?.showLevel ?? 1} onChange={handleLevel} placeholder="选择层级" style={inputStyle} >
                                        {new Array(Math.max(maxLevel, filtParams?.showLevel ?? 1)).fill("").map((item, index) => {
                                            return (
                                                <Option key={index + 1} value={index + 1}>{index + 1}</Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                            </div>
                            <div className="form-group" >
                                <div className="title required">
                                    <span className="txt">行政组织类型</span>
                                    <Tooltip placement="bottomLeft" tip="仅过滤右侧结构图的数据">
                                        <Icon className="icon" type="tips" />
                                    </Tooltip>
                                </div>
                                <div className="info">
                                    <Input className="i-ellipsis-inp"
                                        value={(() => {
                                            return filtParams.showAdminOrgTypes.reduce((s1, s2) => s1 + ";" + s2.name, "").substr(1)
                                        })()}
                                        borderType="bordered"
                                        style={inputStyle}
                                        placeholder="请选择行政组织类型"
                                        suffix={<Icon className="inp-icon" type="search" onClick={makeOpenAdminOrgTypeF7} />}
                                    />
                                </div>
                            </div>
                            <div className="form-group" >
                                <div className="title required">
                                    <span className="txt">汇报及协作关系</span>
                                </div>
                                <div className="info">
                                    <Input
                                        value={filtParams?.showCooprelTypes?.name ?? ""}
                                        borderType="bordered"
                                        style={inputStyle}
                                        placeholder="请选择汇报及协作关系"
                                        suffix={<Icon className="inp-icon" type="search" onClick={makeOpenTeamCooprelTypeF7} />}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    <div className="form-btn-group" >
                        <Button type="primary" loading={searchLoading} onClick={submitFiltForm}>查询</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default APP